module.exports = __webpack_public_path__ + "img/courses-image001.a069f729.jpg";